module.exports = __webpack_public_path__ + "img/house_battery_error_online.f74efa17.png";